import { Group } from "@lib/store";
import { useTranslation } from "react-i18next";
import { ListHeader } from "../ListHeader";
import { Card } from "@atoms";
import { cn } from "@utils";
import { GroupItem } from "./GroupItem";
import { useModal } from "@hooks";
import { GroupInformationSelectionModal } from "../GroupInformationSelectionModal";
import { SectionEmptyCard } from "../SectionEmptyCard";

export const GroupsSection = ({ groups, className }: { groups: Group[]; className?: string }) => {
  const { t } = useTranslation();
  const { openModal, addPages } = useModal();

  const handleCreate = () => {
    addPages([<GroupInformationSelectionModal />]);
    openModal();
  };

  return (
    <Card className={cn("flex flex-col  py-8 gap-6", className)}>
      <ListHeader
        title={`${t("groups:Groups")} (${groups.length})`}
        className="px-4 sm:px-6 md:px-8"
        action={handleCreate}
      />

      <div className="grid divide-y">
        {!!groups.length ? (
          groups.map(group => (
            <GroupItem
              key={`accepted_group_${group.id}`}
              group={group}
            />
          ))
        ) : (
          <SectionEmptyCard
            description={t("groups:GroupsEmptyState")}
            button={{
              label: t("groups:CreateLabel"),
              onClick: handleCreate,
            }}
          />
        )}
      </div>
    </Card>
  );
};
